import rootReducer from './rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import {useDispatch} from "react-redux";
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { getMyPermission } from 'store/slices/workspaceSlice';

const middlewares = [];

const store = configureStore({
	reducer: rootReducer(),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: process.env.NODE_ENV === 'development',
})

store.asyncReducers = {};

if (localStorage.getItem(AUTH_TOKEN)) {
	store.dispatch(getMyPermission());
}

export const useGlobalDispatch = () => useDispatch();

export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(rootReducer(store.asyncReducers));
	return store
}

export default store